import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import React from 'react';

import { createI18nT } from '../i18n.js';
import { validateDocsExtensionType } from './validations.js';

export const generateCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('generate')
    .option(
      '--type <type>',
      t('generate_command.type_flag'),
      validateDocsExtensionType
    )
    .description(t('generate_command.description'))
    .action(async (options, command) => {
      const { GenerateCommand } = await import(
        '../components/GenerateCommand/index.js'
      );
      const { renderCommand } = await import('./render-command.js');
      const { type } = options;
      await renderCommand(
        command,
        services,
        <GenerateCommand docsExtensionType={type} />,
        {
          skipProjectValidation: true,
        }
      );
    });
};
